/*
    🔥 APP PROVIDERS
        Orquestador central de providers globales de React.
        Cada contexto funcional se habilita desde LAYOUTS.CONTEXTS.

    ----------------------------------------------------------------------------
    🔥 PROVIDERS OPCIONALES
        UserAuthenticatedProvider
            Se monta únicamente cuando el módulo de autenticación está habilitado.

        LanguageProvider
            Se monta cuando la aplicación utiliza contexto de traducciones.

        ThemeProvider
            Se monta cuando la aplicación utiliza contexto global de apariencia.

        HelmetProvider
            Se monta cuando están habilitados metadata, SEO y tracking asociado.

        AppToaster
            Se renderiza únicamente cuando el contexto global de notificaciones
            visuales se encuentra habilitado.

    ----------------------------------------------------------------------------
    🔥 ROUTER ESTRUCTURAL
        BrowserRouter permanece montado como infraestructura base.

        🎯 APP_CONFIG_GLOBAL.MODULES.HAS_ROUTING controla el comportamiento funcional de
            routing y guards, pero desmontar BrowserRouter rompería componentes
            que utilizan Link, useNavigate, useLocation u otros hooks estructurales.
*/

import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { ThemeProvider } from "./Theme/ThemeAppContext";
import { LanguageProvider } from "./Translate/useLanguageContext";
import { AppToaster } from "../../App/WEB/_Templates/_UI/Alerts/AppToaster";
import { LAYOUTS } from "../_RuntimeConfig/_Config/_Layouts.js";
import { UserAuthenticatedProvider } from "./_Auth/userAuthenticatedContext";

export const AppProviders = ({ children }) => {
    let CONTENT = (
        <>
            {children}
            {LAYOUTS.CONTEXTS.HAS_TOASTER_CONTEXT && <AppToaster />}
        </>
    );

    if (LAYOUTS.CONTEXTS.HAS_USER_AUTH_CONTEXT) {
        CONTENT = <UserAuthenticatedProvider>{CONTENT}</UserAuthenticatedProvider>;
    }

    CONTENT = <BrowserRouter>{CONTENT}</BrowserRouter>;

    if (LAYOUTS.CONTEXTS.HAS_TRANSLATE_CONTEXT) {
        CONTENT = <LanguageProvider>{CONTENT}</LanguageProvider>;
    }

    if (LAYOUTS.CONTEXTS.HAS_THEME_CONTEXT) {
        CONTENT = <ThemeProvider>{CONTENT}</ThemeProvider>;
    }

    if (LAYOUTS.CONTEXTS.HAS_TRACKING_META_SEO) {
        CONTENT = <HelmetProvider>{CONTENT}</HelmetProvider>;
    }

    return CONTENT;
};
